import React from "react";
import styled, { css, keyframes } from "styled-components";

import Avatar from "antd/es/avatar";

import Icon from "components/Icon";
import { Text } from "components/Text";

const ChatMessageWrapper = styled.div.withConfig({
  shouldForwardProp: (propName) => !["isResponse"].includes(propName),
})`
  width: calc(100% - 16px);
  padding: 16px;
  display: flex;
  gap: 16px;
  align-items: center;

  ${(props) =>
    props.isResponse
      ? css({
          background: "#F0FDFF",
          marginRight: "16px",
          borderRadius: "0px 8px 8px 0px",
        })
      : css({
          background: "#EFF2F5",
          marginLeft: "16px",
          borderRadius: "8px 0px 0px 8px",
        })}
`;

const ChatMessageBody = styled(Text)`
  color: #000000;
  font-size: 14px;
  font-family: Inter;
  font-weight: 400;
  line-height: 22px;
  word-wrap: break-word;
`;

const ChatAvatar = styled(Avatar).withConfig({
  shouldForwardProp: (propName) => !["isBot"].includes(propName),
})`
  min-width: 40px;
  min-height: 40px;

  ${(props) =>
    props.isBot
      ? css({
          background: "#42B0D5",
        })
      : css({
          background: "#ffffff",
        })}
`;

const ChatMessage = ({ messageBody, isResponse }) => {
  return (
    <ChatMessageWrapper isResponse={isResponse}>
      <ChatAvatar
        isBot={isResponse}
        icon={
          isResponse ? (
            <Icon name="lightSparkle" color="#FFFFFF" size={24} />
          ) : (
            <Icon name="user" color="#828C94" size={24} />
          )
        }
        size="large"
      />
      <ChatMessageBody>
        <div
          dangerouslySetInnerHTML={{
            __html: messageBody,
          }}
        />
      </ChatMessageBody>
    </ChatMessageWrapper>
  );
};

const typingKeyframes = keyframes`
  0% {
    transform: translateY(0px);
  }
  28% {
    transform: translateY(-7px);
  }
  44% {
    transform: translateY(0px);
  }
`;

const ChatLoadingDot = styled.div`
  animation: ${css`
    ${typingKeyframes} 1.8s infinite ease-in-out
  `};
  background-color: rgba(37, 162, 211, 0.749);
  border-radius: 50%;
  height: 7px;
  margin-right: 4px;
  vertical-align: middle;
  width: 7px;
  display: inline-block;

  &:nth-child(1) {
    animation-delay: 200ms;
  }

  &:nth-child(2) {
    animation-delay: 300ms;
  }

  &:nth-child(3) {
    animation-delay: 400ms;
  }
`;

const ChatLoadingWrapper = styled.div`
  display: flex;
`;

export const ChatMessageLoading = () => {
  return (
    <ChatMessageWrapper isResponse={true}>
      <ChatAvatar
        isBot={true}
        icon={<Icon name="lightSparkle" color="#FFFFFF" size={24} />}
        size="large"
      />
      <ChatLoadingWrapper>
        <ChatLoadingDot />
        <ChatLoadingDot />
        <ChatLoadingDot />
      </ChatLoadingWrapper>
    </ChatMessageWrapper>
  );
};

export default ChatMessage;
